// extracted by mini-css-extract-plugin
export var lB = "fonts-module--lB--DUXHj";
export var lSB = "fonts-module--lSB--3ZLeH";
export var lM = "fonts-module--lM--1YJiS";
export var lR = "fonts-module--lR--3HWlH";